<template>
  <div class="container-main">
    <bannerVideo bg="#949590" videoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/AI.mp4" allVideoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/AI-all.mp4" title="AI课" message="将AI技术融入到教学场景中，通过人脸识别、动作识别以及答题器的数据反馈，把控授课难度与进度，实现因材施教"></bannerVideo>
    <supportTeacher bg="#F8F9FD" main="优选外教动态授课，与学生高频互动" :imgW="356" :imgH="278" :desH="75"  sub='教学生动有趣，开班周期灵活，机构可随时开班上课' :configList="supportAiList"></supportTeacher>
    <aptitude></aptitude>
    <technology bg="#F8F9FD"></technology>
    <oneImg :main="hardWare.main" :sub="hardWare.sub" :imgUrl="hardWare.imgUrl" :imgW="hardWare.imgW" :imgH="hardWare.imgH"></oneImg>
    <subjectIntro bg="#F8F9FD" main="英语·数学，动态场景让学习更加有趣" sub="让学生不仅爱上学习，还要在快乐中学习" :hasSub="hasSub"></subjectIntro>
    <supportTeacher main="让学生真正爱上学习"  :imgW="355" :imgH="278" :desH="75" :warpNum="3" sub='6000多真实教学场景+课中高频互动参与' :configList="learnAiList"></supportTeacher>
  </div>
</template>
<script>
import bannerVideo from './components/bannerVideo/bannerVideo'
import supportTeacher from './components/supportTeacher'
import subjectIntro from './components/subject-intro'
import oneImg from './components/oneImg'
import aptitude from './components/aptitude'
import technology from './components/technology'
import { ssTeacherTeam, supportAiList, learnAiList } from '@/const/index'
export default {
  data () {
    return {
      teamConfig: ssTeacherTeam,
      hasSub: [2, 3],
      supportAiList: supportAiList,
      learnAiList: learnAiList,
      hardWare: {
        imgUrl: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/live-equipment.png',
        imgW: 890,
        imgH: 556,
        main: '自有硬件稳定有保障',
        sub: 'T-Box 第一款专为智能教学打造的AI终端'
      }
    }
  },
  components: { bannerVideo, supportTeacher, subjectIntro, oneImg, aptitude, technology }
}
</script>
